export type EsimSearchBody = {
  columnFilters: Record<string, string>;
  sort: string[];
  page: number;
  pageSize: number;
  language_code?: "vi" | "en";
};

export const buildEsimSearchBody = (
  columnFilters: Record<string, string> = {},
  options?: Partial<Pick<EsimSearchBody, "page" | "pageSize" | "language_code">>,
): EsimSearchBody => ({
  columnFilters,
  sort: [],
  page: options?.page ?? 0,
  pageSize: options?.pageSize ?? 0,
  language_code: options?.language_code ?? "vi",
});

// /** POST /esim/packages (legacy) — `columnFilters` chỉ gửi `country`. */
// export const buildEsimPackageSearchBody = (
//   country: string,
//   options?: Partial<Pick<EsimSearchBody, "page" | "pageSize" | "language_code">>,
// ): EsimSearchBody =>
//   buildEsimSearchBody({ country: country.trim().toLowerCase() }, options);

/** POST /esim/catalog/public/list — trả cả `vi`/`en` trong `informationMeta`, không cần `language_code`. */
export const buildEsimCatalogPublicListBody = (
  countryCode: string,
  options?: Partial<{ page: number; limit: number }>,
) => ({
  countries: [countryCode.trim().toLowerCase()],
  page: options?.page ?? 1,
  limit: options?.limit ?? 100,
});

/** POST /esim/catalog/public/list — free-text `search` (khớp OR trên gggPlanId/parentGroupName/data/validity/countries/collection). */
export const buildEsimCatalogSearchBody = (
  search: string,
  options?: Partial<{ page: number; limit: number }>,
) => ({
  search: search.trim(),
  page: options?.page ?? 1,
  limit: options?.limit ?? 10,
});

/** POST /esim/catalog/public/list — cho trang kết quả tìm kiếm: gửi `search`/`countries`/`countriesAny`/
 * `data`/`validity`/`collectionId` nếu người dùng điền. `countries` (AND, giữ cho tương thích ngược —
 * link 1 quốc gia từ tab Phổ biến/Quốc gia) độc lập với `countriesAny` (OR — sidebar filter đa chọn,
 * tab Khu Vực), có thể truyền cả 2 nhưng UI hiện tại chỉ dùng 1 trong 2 tại một thời điểm. */
export const buildEsimCatalogCombinedSearchBody = (
  params: {
    search?: string;
    countryCode?: string;
    countriesAny?: string[];
    data?: string;
    validity?: string;
    collectionId?: string;
  },
  options?: Partial<{ page: number; limit: number }>,
) => ({
  ...(params.search?.trim() ? { search: params.search.trim() } : {}),
  ...(params.countryCode?.trim() ? { countries: [params.countryCode.trim().toLowerCase()] } : {}),
  ...(params.countriesAny?.length
    ? { countriesAny: params.countriesAny.map((code) => code.trim().toLowerCase()).filter(Boolean) }
    : {}),
  ...(params.data?.trim() ? { data: params.data.trim() } : {}),
  ...(params.validity?.trim() ? { validity: params.validity.trim() } : {}),
  ...(params.collectionId?.trim() ? { collectionId: params.collectionId.trim() } : {}),
  page: options?.page ?? 1,
  limit: options?.limit ?? 10,
});

/** POST /esim/catalog/public/detail — trả 1 esim kèm `content`/`collectionContent`. */
export const buildEsimCatalogPublicDetailBody = (gggPlanId: string) => ({
  gggPlanId,
});

/** POST /product-content/public/list — content đứng độc lập theo `position` (vd `PRODUCT_HOME`), api_guide mục B.2. */
export const buildProductContentPublicListBody = (
  productType: string,
  position: string[],
  options?: Partial<{ page: number; limit: number }>,
) => ({
  productType,
  position,
  page: options?.page ?? 1,
  limit: options?.limit ?? 10,
});

/** POST /esim/collection/public/list — duyệt danh mục, mỗi collection kèm sẵn 1 trang `esim[]` + content. */
export const buildEsimCollectionPublicListBody = (
  options?: Partial<{ page: number; limit: number; esimPage: number; esimLimit: number }>,
) => ({
  page: options?.page ?? 1,
  limit: options?.limit ?? 10,
  esimPage: options?.esimPage ?? 1,
  esimLimit: options?.esimLimit ?? 1,
});
